/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { rowSpacing, enterpriseCSS } from './variables';

export const innerModal = (typography, palette) => ({
    innerModal: {
        // height: 'calc(100vh - 250px)',
        width: `calc(100vw - ${rowSpacing * 2}px)`,
        padding: rowSpacing,
        display: 'flex',
        flexWrap: 'wrap',
        flexFlow: 'row wrap',
        overflowY: 'scroll',
        alignItems: 'center',
        alignContent: 'flex-start',
        flexDirection: 'row',
        justifyContent: 'left',
        backgroundColor: palette.common?.white,
        margin: 'auto',
        borderRadius: '4px',
        outline: 'none',
        transform: 'translate(-50%, -50%)',
        position: 'absolute',
        top: '50%',
        left: '50%',

        '&.dialog': {
            padding: rowSpacing * 2,
            '@media (min-width: 768px)': {
                width: 500,
                overflow: 'auto',
            },
            '@media (max-width: 767px)': {
                width: `calc(100vw - ${rowSpacing * 2}px)`,
            },

            '&.desktop': {
                'overflow-y': 'auto',
                'max-width': '1024px',
                paddingTop: 0,
                borderRadius: 0,
                '&.wide': {
                    width: '800px !important',
                },
                '&.smallWidth': {
                    'max-width': '600px',
                },
                '& .mainBillingCard': {
                    marginTop: 22, // TODO
                    position: 'relative',
                    display: 'block',
                    overflow: 'hidden',
                    minHeight: '400px',
                    '&.no-card-info': {
                        '& .billRigthtSide': {
                            width: '680px !important',
                            float: 'none',
                            margin: '0 auto',
                        },
                    },
                    '& .buttonForm': {
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                    },
                    '& .checkbox-selecter': {
                        paddingLeft: 0,
                    },
                },
                '&.compare-2-products': {
                    width: 234 * 2 + 24 + 48,
                },
                '&.compare-3-products': {
                    width: 234 * 3 + 24 * 2 + 48,
                },
                '&.compare-4-products': {
                    'max-width': 234 * 4 + 24 * 3 + 48,
                    'min-width': 234 * 4 + 24 * 3 + 48,
                },

                '& .modal-title': {
                    padding: `10px ${rowSpacing * 2}px`,
                    'margin-left': `-${rowSpacing * 2}px`,
                    'margin-right': `-${rowSpacing * 2}px`,
                    width: `calc(100% + ${rowSpacing * 4}px)`,
                    backgroundColor: enterpriseCSS.palette.modal.title.backgroundColor,

                    '& h2': {
                        color: `${enterpriseCSS.palette.modal.title.color} !important`,
                        fontSize: enterpriseCSS.palette.modal.title.size,
                    },
                    '& .x-icon': {
                        cursor: 'pointer',
                    },
                },

                '& .modal-content-wrapper': {
                    'overflow-y': 'auto',
                },
            },

            '&.no-x-button .modal-title .x-icon': {
                display: 'none',
            },

            '& button span:first-child': {
                maxWidth: 'calc(100vw - (12px + 24px + 16px) * 2)',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                'text-overflow': 'ellipsis',
                display: 'inline-block',
            },

            '&.small-dailog': {
                width: '100%',
                maxWidth: '450px',
                marginLeft: 'auto',
                marginRight: 'auto',
                overflow: 'hidden',
                borderRadius: 0,
                '& p': {
                    textAlign: 'center',
                    fontSize: '18px',
                    '&.left': {
                        textAlign: 'left',
                    },
                    '&.bodySize': {
                        fontSize: 14,
                    },
                },
                '& .modal-content-wrapper': {
                    overflow: 'hidden',
                },
                '& .empty-title >svg': {
                    display: 'none',
                },
                '& .buttonForm': {
                    borderTop: 'unset',
                    '& .buttonDelete': {
                        float: 'unset',
                    },
                    '& .buttonCancel': {
                        float: 'unset',
                    },
                    '& button': {
                        marginRight: 0,
                        width: '135px',
                    },
                },
                '& .desktop-dialog-btn-wrapper': {
                    textAlign: 'center',
                    paddingTop: rowSpacing * 2,
                },
                '&:not(.HD) button': {
                    minWidth: 100,
                    borderRadius: '2px !important',
                    color: palette.common?.white,
                    border: `1px solid ${enterpriseCSS.palette.darkRed}`, // TODO
                    fontSize: '1em',
                    textTransform: 'capitalize',
                    fontWeight: 'bold',
                    backgroundColor: enterpriseCSS.palette.darkRed,
                    '&:hover': {
                        color: palette.common?.white,
                        border: `1px solid ${enterpriseCSS.palette.hoverRed}`, // TODO
                        backgroundColor: enterpriseCSS.palette.hoverRed,
                    },
                    '&.red': {
                        border: `1px solid ${palette.snipeTextPromo}`, // TODO
                        backgroundColor: palette.snipeTextPromo, // TODO
                        '&:hover': {
                            backgroundColor: palette.snipeTextPromo, // TODO
                        },
                    },
                    '&.secondary': {
                        backgroundColor: palette.common?.white,
                        color: enterpriseCSS.palette.button.darkGray, // TODO
                        border: `1px solid ${enterpriseCSS.palette.button.darkGray}`, // TODO
                        '&:hover': {
                            backgroundColor: enterpriseCSS.palette.button.darkGray,
                            color: enterpriseCSS.palette.white, // TODO
                            border: `1px solid ${enterpriseCSS.palette.button.darkGray}`,
                        },
                    },
                },
                '&.HD button': {
                    fontFamily: typography.fontFamily,
                    boxSizing: 'border-box',
                    WebkitFontSmoothing: 'antialiased',
                    fontWeight: '700',
                    width: 'auto',
                    minWidth: 120,
                    fontSize: '1em',
                    textTransform: 'none',
                    borderRadius: '20px',
                    padding: '6px 40px',
                    boxShadow: 'none',
                    // primary button
                    color: palette.common?.white,
                    backgroundColor: `${palette.primaryButton}`,
                    border: `1px solid ${palette.primaryButton}`,
                    '&:hover': {
                        color: `${palette.common?.white} !important`, // TODO
                        border: `1px solid ${palette.cms?.primary_hover}` || 'd73833',
                        backgroundColor: palette.cms?.primary_hover || 'd73833', // TODO
                    },
                    '&[disabled]': {
                        color: palette.grey8, // TODO
                        border: `1px solid ${palette.grey['300']}`, // TODO
                        backgroundColor: palette.grey['300'], // TODO
                    },
                    // secondary button
                    '&.secondary': {
                        color: palette.cms?.secondary,
                        backgroundColor: palette.common?.white,
                        border: `1px solid ${palette.cms?.secondary}`,
                        '&:hover': {
                            color: palette.common?.white,
                            border: `1px solid ${palette.cms?.secondary}`,
                            backgroundColor: palette.cms?.secondary,
                        },
                        '&[disabled]': {
                            color: palette.grey8,
                            border: `1px solid ${palette.grey['300']}`,
                            backgroundColor: palette.grey['300'],
                        },
                    },
                    '&.tertiary': {
                        color: palette.common?.white,
                        backgroundColor: palette.cms?.tertiary_font_color,
                        border: `1px solid ${palette.cms?.tertiary_font_color}`,
                        '&:hover': {
                            color: palette.common?.white, // TODO
                            border: `1px solid ${palette.cms?.tertiary_hover}`, // TODO
                            backgroundColor: palette.cms?.tertiary_hover, // TODO
                        },
                        '&[disabled]': {
                            color: palette.grey8, // TODO
                            border: `1px solid ${palette.grey['300']}`, // TODO
                            backgroundColor: palette.grey['300'], // TODO
                        },
                    },
                },
            },

            '&.headless': {
                '& .modal-title': {
                    display: 'none',
                },
                '& .modal-content-wrapper': {
                    marginTop: rowSpacing * 2,
                },
            },
        },

        '&.has-footer-content-inside': {
            backgroundColor: 'transparent',
            padding: 0,
            width: `calc(100vw - ${rowSpacing * 2}px)`,
            'overflow-x': 'hidden',

            '& .modal-title': {
                backgroundColor: palette.common?.white,
                padding: rowSpacing,
                paddingBottom: `${rowSpacing * 2}px`,
                marginBottom: '-1px', // Fix 1 px spacing below the title caused by overflow-x: hidden;
            },

            '& .modal-content': {
                backgroundColor: palette.common?.white,
                marginLeft: 0,
                'border-bottom-left-radius': '4px',
                'border-bottom-right-radius': '4px',
                maxHeight: `calc(100vh - ${rowSpacing * 20}px - 50px)`,
                minWidth: `calc(100vw - ${rowSpacing * 20}px)`,
            },
            '& .carousel-container': {
                marginBottom: rowSpacing,
                minHeight: '320px',
            },
            '& .shop-the-site-wrapper': {
                '& h2': { color: `${palette.common?.white} !important` },
            },
        },

        '& .max-width-100vw': { 'max-width': '100vw' },

        '& .modal-title': {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            paddingBottom: rowSpacing,
            '&.empty-title': {
                paddingBottom: 0,
                marginBottom: `-${rowSpacing * 2}px`,
            },

            '& > *:not(svg)': { flex: 1 },
        },

        '& .modal-content-wrapper': {
            width: '100%',
            'max-height': `calc(100vh - ${rowSpacing * 12}px)`,
            '@media (min-width: 768px)': {
                overflow: 'auto',
            },
            '@media (max-width: 767px)': {
                'overflow-y': 'scroll',
                'overflow-x': 'hidden',
            },
            '& .modal-error-icon': {
                float: 'left',
                color: enterpriseCSS.palette.error,
                width: `${rowSpacing * 4}px`,
                height: `${rowSpacing * 4}px`,
                marginRight: `${rowSpacing}px`,
            },
            '& > p:last-child': {
                marginBottom: 0,
            },
        },

        '& .modal-content': {
            'max-width': `calc(100vw - ${rowSpacing * 2}px)`,
            'margin-left': `${rowSpacing * -1}px`,
            'overflow-x': 'hidden',
            'max-height': `calc(100vh - ${rowSpacing * 20}px)`,
            'min-height': `${rowSpacing * 10}px`,

            '& > *': {
                'margin-left': rowSpacing,
                'margin-right': rowSpacing,
            },
        },

        '& .product-content-ul': {
            'max-height': '340px',
            'overflow-y': 'scroll',
        },
    },
});

export default {
    innerModal,
};
